import classNames from 'classnames';

interface MoveButtonsProps {
  canMoveUp: boolean;
  canMoveDown: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
}

const Chevron = ({ up }: { up?: boolean }) => (
  <svg
    className={classNames('w-4 h-4', { 'rotate-180': up })}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
);

const MoveButtons = ({ canMoveUp, canMoveDown, onMoveUp, onMoveDown }: MoveButtonsProps) => (
  <div className="flex items-center gap-1 text-neutral-80" onClick={(e) => e.stopPropagation()}>
    <button
      type="button"
      title="Move up"
      disabled={!canMoveUp}
      onClick={onMoveUp}
      className="p-1 rounded hover:bg-neutral-20 disabled:opacity-25 disabled:hover:bg-transparent"
    >
      <Chevron up />
    </button>
    <button
      type="button"
      title="Move down"
      disabled={!canMoveDown}
      onClick={onMoveDown}
      className="p-1 rounded hover:bg-neutral-20 disabled:opacity-25 disabled:hover:bg-transparent"
    >
      <Chevron />
    </button>
  </div>
);

export default MoveButtons;
